var _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSwipeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 3,
    viewBox: "0 0 50 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 3,
    rx: 1.5,
    fill: "#C4C4C4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwipeLine);
export default __webpack_public_path__ + "static/media/icon_swipe_line.43788c0fb738de4d84151d8838acd5ce.svg";
export { ForwardRef as ReactComponent };